const charMap = {
    '’': "'",
    '“': '"',
    '”': '"',
};
export const sanitizeQuotes = (text) => text.replace(/[’“”]/g, (char) => charMap[char]);
